export const searchLayoutType = {
  grid: "grid",
  masonry: "masonry",
  row: "row"
};
